export const CLIENTS_HERO_POSTER = '/images/clients-proof-hero.png';

export const clientsCriticalHero: Record<string, unknown> = {
  eyebrow: 'SELECTED CLIENT PROOF',
  heading: 'Work that stays grounded in real organizations and communities.',
  body: 'A carefully selected record of public client and engagement references from Kim Kelley\'s legacy portfolio. Each item is carried forward only when the legacy source supports it.',
  primaryCta: 'Start the readiness assessment',
  primaryHref: '/workshop-readiness',
  poster: CLIENTS_HERO_POSTER,
};

export const criticalHeroForPath = (pathname: string): Record<string, unknown> | null => {
  const normalized = pathname === '/' ? pathname : pathname.replace(/\/+$/, '');
  return normalized === '/clients' ? clientsCriticalHero : null;
};

export const optimizedHeroSources = (poster: string): { avif: string; webp: string } | null => poster === CLIENTS_HERO_POSTER
  ? {
      avif: '/images/clients-proof-hero.avif',
      webp: '/images/clients-proof-hero.webp',
    }
  : null;
